
const configContents = ({ state: { langStrings, caseNumber } }) => [
    {
      isTitle: true,
      hasSuccessMark: true,
      description: langStrings
        ? langStrings.contactOptions.caseSubmitted
        : 'Success',
      id: 'adsk-page-title',
    },
    {
      description: langStrings
        ? langStrings.contactOptions.caseNumber + caseNumber
        : `Case number: <strong>${caseNumber}</strong>`,
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      description: langStrings
        ? langStrings.contactOptions.caseConfirm1
        : 'You will receive an email confirmation shortly. If you do not receive an email, check your email junk/spam folder.',
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      description: langStrings
        ? langStrings.contactOptions.caseConfirm2
        : 'An agent will review your case and get back to you within 2 business days.',
      paragraphStyle: { marginBottom: '20px' },
    },
  ];

const configFooter = ({ state: { hasExtension, langStrings }, dispatch }) => ({
  hasExtension,
  hideBackButton: true,
  nextButtonContent: langStrings
    ? langStrings.buttons.restartButton
    : 'RESTART',
  handleNext: () => {
    dispatch({ type: 'RESTART_WIDGET' })
    window.location.reload(true);
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => dispatch({ type: 'AGENT_LOADED' }),
  handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleAgentAnalytics: () =>  {}, 
  // handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-hula-restart-button',
  handleBackButtonId: 'adsktm-cm-back-button',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
});

export default {
  configContents,
  configFooter,
};
